import Vimeo from '@u-wave/react-vimeo';
import { Anchor, Box, Text } from 'grommet';
import { Video } from 'grommet-icons';
import React, { useState } from 'react';

const VIDEO_URL = 'https://vimeo.com/951410809/88a70ce689?share=copy';

export const HighlightVideo = () => {
  const [failed, setFailed] = useState(false);

  return (
    <Box align="center" justify="center" gap="medium" fill="horizontal">
      <Box
        width={{ max: '600px' }}
        margin="medium"
        fill="horizontal"
      >
        {failed ? (
          <Box
            align="center"
            justify="center"
            gap="small"
            pad="large"
            round="small"
            border={{ color: 'light-4', size: 'small' }}
            background="light-1"
            style={{ aspectRatio: '16/9' }}
          >
            <Video size="large" color="dark-4" />
            <Text color="dark-4" size="small">Videoen kunne ikke lastes.</Text>
            <Anchor href={VIDEO_URL} target="_blank" label="Se video på Vimeo →" size="small" />
          </Box>
        ) : (
          <Vimeo
            video={VIDEO_URL}
            responsive
            onError={() => setFailed(true)}
          />
        )}
      </Box>
    </Box>
  );
};
